var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgContract = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16661 2.72223C4.08328 2.72223 2.72217 5.15862 2.72217 8.16667V28.5833C2.72217 29.7131 4.00161 30.3528 4.89995 29.6722L7.22745 27.93C7.77189 27.5217 8.53411 27.5761 9.02411 28.0661L11.2836 30.3392C11.8144 30.87 12.6855 30.87 13.2163 30.3392L15.503 28.0525C15.9794 27.5761 16.7416 27.5217 17.2724 27.93L19.5999 29.6722C20.4983 30.3392 21.7777 29.6995 21.7777 28.5833V5.44445C21.7777 3.94723 23.0027 2.72223 24.4999 2.72223H8.16661ZM15.3124 18.7153H9.18745C8.62939 18.7153 8.16661 18.2525 8.16661 17.6945C8.16661 17.1364 8.62939 16.6736 9.18745 16.6736H15.3124C15.8705 16.6736 16.3333 17.1364 16.3333 17.6945C16.3333 18.2525 15.8705 18.7153 15.3124 18.7153ZM16.3333 13.2708H8.16661C7.60856 13.2708 7.14578 12.8081 7.14578 12.25C7.14578 11.692 7.60856 11.2292 8.16661 11.2292H16.3333C16.8913 11.2292 17.3541 11.692 17.3541 12.25C17.3541 12.8081 16.8913 13.2708 16.3333 13.2708Z",
    fill: "url(#paint0_linear_675_2958)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5137 4.7639C25.4121 4.7639 26.2696 5.1314 26.8957 5.7439C27.549 6.41084 27.9029 7.26834 27.9029 8.16667V11.4606C27.9029 12.4678 27.4537 12.9306 26.4329 12.9306H23.8196V5.45806C23.8196 5.07695 24.1326 4.7639 24.5137 4.7639ZM24.5137 2.72223C23.0029 2.72223 21.7779 3.94723 21.7779 5.45806V14.9722H26.4329C28.5835 14.9722 29.9446 13.6111 29.9446 11.4606V8.16667C29.9446 6.66945 29.3321 5.30834 28.3521 4.31473C27.3585 3.33473 26.011 2.73584 24.5137 2.72223Z",
    fill: "url(#paint1_linear_675_2958)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_675_2958",
    x1: 2.72217,
    y1: 14.6286,
    x2: 29.9446,
    y2: 14.6286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_675_2958",
    x1: 2.72217,
    y1: 14.6286,
    x2: 29.9446,
    y2: 14.6286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContract, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/contract.22e7048d.svg";
export { ForwardRef as ReactComponent };